import { Link } from 'react-router-dom';

export default function CtaBand() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100 border-t border-background-200">
      <div className="relative w-full rounded-2xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20sunset%20gradient%20with%20floating%20gift%20boxes%20sparkles%20and%20confetti%20abstract%20background%2C%20coral%20orange%20and%20amber%20palette%2C%20artistic%20non%20realistic%20illustration%2C%20soft%20glow&width=1600&height=700&seq=cta-baogua-01&orientation=landscape"
          alt="福利活动氛围抽象插画"
          title="爆瓜福利 - 开启你的第一次福利"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
        <div className="relative z-10 px-6 md:px-14 py-12 md:py-20 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs">
              <i className="ri-arrow-up-circle-line"></i>
              从今天开始
            </span>
            <h2 className="mt-4 text-2xl md:text-4xl text-white leading-tight">
              挑一个活动，把第一笔福利领到手
            </h2>
            <p className="mt-4 text-sm md:text-base text-white/80 leading-relaxed">
              不需要复杂准备，从每日签到开始就好。攒下的瓜豆可以抽奖，也能在兑换专区换成实物好物。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0">
            <Link
              to="/activities"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-gift-line"></i>
              去活动中心
            </Link>
            <Link
              to="/faq"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-background-50/10 border border-background-50/40 text-background-50 text-base font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              先看常见问题
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}